import { colors, Field, mixin } from "@hubrise/react-components"
import styled, { css } from "styled-components"

export const clickableRoundIcon = css`
  width: 1.8rem;
  padding: 0.35rem;
  border-radius: 50%;
  ${mixin.clickable};
  ${mixin.centerElement};

  &:hover {
    background-color: ${colors.backgroundLight};
  }
`

export const AppearingCheckbox = styled(Field.Checkbox).attrs({ withMargin: false })<{ $visible: boolean }>`
  padding-left: 0.25rem; // To avoid cutting the shadow on focus
  overflow: hidden;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  max-height: ${({ $visible }) => ($visible ? "2rem" : "0")};
  transition:
    opacity 0.2s ease,
    max-height 0.2s ease;
`
